import "./App.css";
import Routes from "./routes";
import { Provider } from "react-redux";
import generateStore from "./ducks/store";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
function App() {
  const store = generateStore();
  const theme = createTheme({
    palette: {
      primary: {
        main: "#009bdb",
      },
      secondary: {
        main: "#69a33b",
      },
      warning: {
        main: "#FFFF00"
      }
    },
  });
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
    </Provider>
  );
}
export default App;
